import { SupabaseMission } from '../types/missions';
import { UserCard } from '../types/pokemon';

export function useMissionProgress() {
  const calculateProgress = (mission: SupabaseMission, collection: Record<number, UserCard>) => {
    if (!mission.mission_card_groups || mission.mission_card_groups.length === 0) {
      return 0;
    }

    const completedGroups = mission.mission_card_groups.filter(group => {
      if (!group.mission_card_variants || group.mission_card_variants.length === 0) {
        return false;
      }

      // Vérifie si au moins une variante de la carte est dans la collection
      return group.mission_card_variants.some(variant => {
        const userCard = collection[variant.card_id];
        return userCard && userCard.quantity > 0;
      });
    });

    return Math.round((completedGroups.length / mission.mission_card_groups.length) * 100);
  };

  return {
    calculateProgress
  };
} 